import { createUseStyles } from "react-jss";

export default createUseStyles({
    snakeGame: {
        backgroundColor: "#f1f5f8",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    button: {
        borderRadius: "15%",
        padding: "0.5rem",
        margin: "1rem"
    }
});